document.addEventListener("DOMContentLoaded", function () {
	const accordions = document.querySelectorAll(".accordion");

	accordions.forEach(function (accordion, accIndex) {
		const items = accordion.querySelectorAll(".accordion-item");
		const buttons = [];

		items.forEach(function (item, index) {
			const button = item.querySelector(".accordion-button");
			const panel = item.querySelector(".accordion-info");

			// Eindeutige IDs
			const btnId = `accordion-${accIndex}-btn-${index}`;
			const panelId = `accordion-${accIndex}-panel-${index}`;

			// Button ARIA
			button.setAttribute("id", btnId);
			button.setAttribute("aria-controls", panelId);
			button.setAttribute(
				"aria-expanded",
				item.classList.contains("accordion-item--show") ? "true" : "false"
			);

			// Panel ARIA
			panel.setAttribute("id", panelId);
			panel.setAttribute("role", "region");
			panel.setAttribute("aria-labelledby", btnId);

			// Initial inert state
			if (!item.classList.contains("accordion-item--show")) {
				panel.setAttribute("inert", "");
			}

			buttons.push(button);

			// Click event
			button.addEventListener("click", function () {
				const isOpen = item.classList.contains("accordion-item--show");

				// Toggle this item
				item.classList.toggle("accordion-item--show");
				button.setAttribute("aria-expanded", String(!isOpen));
				if (isOpen) {
					panel.setAttribute("inert", "");
				} else {
					panel.removeAttribute("inert");
				}

				// Close other items
				items.forEach(function (otherItem) {
					if (otherItem !== item) {
						otherItem.classList.remove("accordion-item--show");
						const otherButton = otherItem.querySelector(".accordion-button");
						const otherPanel = otherItem.querySelector(".accordion-info");

						otherButton.setAttribute("aria-expanded", "false");
						otherPanel.setAttribute("inert", "");
					}
				});
			});

			// Keyboard navigation (ARIA Accordion Pattern)
			button.addEventListener("keydown", function (e) {
				const currentIndex = buttons.indexOf(button);

				switch (e.key) {
					case "ArrowDown":
						e.preventDefault();
						buttons[(currentIndex + 1) % buttons.length].focus();
						break;
					case "ArrowUp":
						e.preventDefault();
						buttons[(currentIndex - 1 + buttons.length) % buttons.length].focus();
						break;
					case "Home":
						e.preventDefault();
						buttons[0].focus();
						break;
					case "End":
						e.preventDefault();
						buttons[buttons.length - 1].focus();
						break;
				}
			});
		});
	});
});
